import { actions } from './actions';

const initialState = {
  total: null,
  attachments: [],
  error: false,
};

export const videoAttachmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.VIDEO_ATTACHMENTS_FETCH_REQUEST:
      return {
        ...state,
        error: false,
      };

    case actions.VIDEO_ATTACHMENTS_FETCH_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: false,
      };

    case actions.VIDEO_ATTACHMENTS_FETCH_ERROR:
      return {
        ...state,
        error: true,
      };

    case actions.VIDEO_ATTACHMENTS_RESET:
      return initialState;

    default:
      return state;
  }
};
